import { textEditingUpdateTextMaker } from 'utils/actions';

export const COMMENTS_FETCH = 'COMMENTS_FETCH';
export const COMMENTS_FETCH_SUCCESS = 'COMMENTS_FETCH_SUCCESS';
export const COMMENTS_FETCH_ERROR = 'COMMENTS_FETCH_ERROR';
export const commentsFetch = (page = 1, pageSize, commentsQuery, isForLiveList = false) => ({
  type: COMMENTS_FETCH,
  page,
  pageSize,
  resourceType: commentsQuery.resourceType,
  resourceId: commentsQuery.resourceId,
  commentsQuery,
  commentsQueryString: JSON.stringify(commentsQuery),
  isForLiveList
});

export const COMMENTS_RECEIVED = 'COMMENTS_RECEIVED';
export const commentsReceived = (result, isForLiveList = false) => ({type: COMMENTS_RECEIVED, result, isForLiveList});

export const COMMENT_UPDATE = 'COMMENT_UPDATE';
export const commentUpdate = (commentId, stateBeforeLocalUpdate, updates) => ({
  type: COMMENT_UPDATE,
  commentId,
  stateBeforeLocalUpdate,
  updates
});

export const COMMENT_REPLY_BEGIN = 'COMMENT_REPLY_BEGIN';
export const commentReplyBegin = commentId => ({type: COMMENT_REPLY_BEGIN, commentId});

export const COMMENT_REPLY_CANCEL = 'COMMENT_REPLY_CANCEL';
export const commentReplyCancel = () => ({type: COMMENT_REPLY_CANCEL});

export const COMMENT_EMOJIS_SHOW = 'COMMENT_EMOJIS_SHOW';
export const commentEmojisShow = key => ({type: COMMENT_EMOJIS_SHOW, key});

export const COMMENT_EMOJIS_HIDE = 'COMMENT_EMOJIS_HIDE';
export const commentEmojisHide = key => ({type: COMMENT_EMOJIS_HIDE, key});

export const COMMENT_UPDATE_TEXT = 'COMMENT_UPDATE_TEXT';
export const commentUpdateText = textEditingUpdateTextMaker(COMMENT_UPDATE_TEXT);

export const COMMENT_EXPAND = 'COMMENT_EXPAND';
export const commentExpand = key => ({type: COMMENT_EXPAND, key});

export const COMMENT_RESET = 'COMMENT_RESET';
export const commentReset = key => ({type: COMMENT_RESET, key});

export const COMMENT_CREATE = 'COMMENT_CREATE';
export const COMMENT_CREATE_SUCCESS = 'COMMENT_CREATE_SUCCESS';
export const COMMENT_CREATE_ERROR = 'COMMENT_CREATE_ERROR';
export const commentCreate = (text, key, resourceType, resourceId, successTitle, successMessage) => ({
  type: COMMENT_CREATE,
  text,
  key,
  resourceType,
  resourceId,
  successTitle,
  successMessage
});

export const COMMENTS_RESET_REPLIES_RELATED_PROPERTIES = 'COMMENTS_RESET_REPLIES_RELATED_PROPERTIES';
export const commentsResetRepliesRelatedProperties = () => ({type: COMMENTS_RESET_REPLIES_RELATED_PROPERTIES});

export const COMMENTS_UPDATE_POSSIBLE_PAGE = 'COMMENTS_UPDATE_POSSIBLE_PAGE';
export const commentsUpdatePossiblePage = (possiblePage, commentsQuery) => ({
  type: COMMENTS_UPDATE_POSSIBLE_PAGE,
  possiblePage,
  commentsQuery,
  commentsQueryString: JSON.stringify(commentsQuery)
});

export const COMMENT_MARK_AS_USEFUL = 'COMMENT_MARK_AS_USEFUL';
export const COMMENT_MARK_AS_USEFUL_SUCCESS = 'COMMENT_MARK_AS_USEFUL_SUCCESS';
export const COMMENT_MARK_AS_USEFUL_ERROR = 'COMMENT_MARK_AS_USEFUL_ERROR';
export const commentMarkAsUseful = (commentId, resourceType, useful) => ({type: COMMENT_MARK_AS_USEFUL, commentId, resourceType, useful});

export const COMMENTS_CHANGE_SORT = 'COMMENTS_CHANGE_SORT';
export const commentsChangeSort = value => ({type: COMMENTS_CHANGE_SORT, value});

export const COMMENTS_RESET_LIVE_LIST = 'COMMENTS_RESET_LIVE_LIST';
export const commentsResetLiveList = () => ({type: COMMENTS_RESET_LIVE_LIST});



/** WEBPACK FOOTER **
 ** ./src/members/state/comments/actions.js
 **/